<template>
  <div>
    <h1>Registrar geocerca</h1>
    <div class="card">
      <div class="card-body">
        <a-form :form="form" @submit.prevent="handleSubmit" layout="vertical">
          <div class="row">
            <div class="col-md-6">
              <label>Geocerca (adjuntar archivo .kmz)</label>
              <b-form-file
                v-model="$v.geofence.file.$model"
                ref="file"
                :state="fileState"
                placeholder="Geocerca"
                browse-text="Adjuntar"
                drop-placeholder="Drop file here..."
                @change="onFileSelected"
                required
                accept=".KMZ"
                ></b-form-file>
            </div>
            <div class="col-md-6">
              <a-form-item label="Nombre de la geocerca">
                <a-input ref="name" placeholder="Nombre de la geocerca" v-model="$v.geofence.name.$model" />
                <small class="text-danger" v-if="!$v.geofence.name.required">Campo requerido. No debe estar vacío.</small><br>
                <small class="text-danger" v-if="!validateRegisteredGeofence($v.geofence.name.$model)">Ya existe un registro con este nombre</small>
              </a-form-item>
            </div>
            <div class="col-12">
              <a-form-item>
                <button ref="button" type="submit" class="btn btn-light px-5" :disabled="!(validateRegisteredGeofence($v.geofence.name.$model) && !$v.$invalid)">
                  Registrar
                </button>
              </a-form-item>
            </div>
          </div>
        </a-form>
      </div>
    </div>
  </div>
</template>
<script>
import { required } from 'vuelidate/lib/validators'
import { uploadFileS3 } from '../../../s3/s3Up.js'
import gql from 'graphql-tag'
import headers from '@/config/headers.js'
const CREATE_GEOFENCE = gql`
  mutation createGeofence($kmzFile: String, $name: String, $createdBy: String){
    createGeofence(geofenceRequest: { kmzFile: $kmzFile name: $name createdBy: $createdBy }){
      kmzFile
      name
      createdBy
    }
  }
`
const GET_ALL_GEOFENCES = gql`
  query getAllGeofences{
    getAllGeofences{
      id
      name
    }
  }
`
export default {
  data() {
    return {
      form: this.$form.createForm(this),
      geofence: {
        file: null,
        name: '',
      },
      fileState: null,
      createdBy: this.$store.state.user.email,
      registeredGeofences: {},
    }
  },
  apollo: {
    getAllGeofences: {
      query: GET_ALL_GEOFENCES,
      context: headers(),
      result({ data }) {
        data.getAllGeofences.forEach(geofence => {
          this.registeredGeofences[geofence.name] = 1
        })
      },
    },
  },
  methods: {
    onFileSelected(event) {
      this.geofence.file = event.target.files[0]
      // console.log(this.geofence.file)
    },
    validateRegisteredGeofence(name) {
      if (this.registeredGeofences[name.trim()]) {
        return false
      } else {
        return true
      }
    },
    disableForm() {
      this.$refs.button.disabled = true
      this.$refs.file.disabled = true
      this.$refs.name.disabled = true
    },
    async handleSubmit() {
      const file = []
      file.fileExtension = this.geofence.file.name.split('.').pop()
      file.fileUploaded = this.geofence.file
      console.log(file)
      // console.log(this.geofence.name)
      this.disableForm()
      // console.log(this.$refs)
      const uploadedFile = await uploadFileS3(file)
      console.log(uploadedFile)
      this.$apollo.mutate({
        mutation: CREATE_GEOFENCE,
        context: headers(),
        variables: {
          kmzFile: uploadedFile.Key,
          name: this.geofence.name,
          createdBy: this.createdBy,
        },
      })
        .then(data => {
          console.log(data)
          this.$router.push({ name: 'GetGeofences' })
        })
        .catch(err => {
          console.log(err)
        })
    },
  },
  validations: {
    geofence: {
      file: { required },
      name: { required },
    },
  },
}
</script>
